import React from "react";
import { ExportButton } from "components/ExportButton/ExportButton";
import { default as dayjs } from "dayjs";
import { PieChartDataPoint } from "./PieChart";

interface Props {
  data: PieChartDataPoint[];
  from: Date;
  to: Date;
  title: string;
}

interface ExportedDataRow {
  name: string;
  value: number;
  [key: string]: string | number;
}

const columnHeaders: Record<keyof ExportedDataRow, string> = {
  name: "Name",
  value: "Count"
};

const ExportPieChartButton: React.FC<Props> = ({ data, from, to, title }) => {
  const getExportData = React.useCallback(async (): Promise<ExportedDataRow[]> => {
    return data.map(item => ({
      name: item.name,
      value: item.value
    }));
  }, [data]);

  const fileName = `${title.replace(/\s+/g, "-")}-${dayjs(from).format("MM-DD-YYYY")}-${dayjs(to).format("MM-DD-YYYY")}.csv`;

  return (
    <ExportButton<ExportedDataRow>
      filename={fileName}
      columnHeaders={columnHeaders}
      getExportData={getExportData}
      exportingMessage="Exporting chart data..."
    />
  );
};

export { ExportPieChartButton };
